// src/services/settingService/settingService.ts
import axios from 'axios';
import {SettingResult, UpdateSettingValueRequest} from './models/SettingTypes';
import {BaseResponseType} from "../shared-models/sharedTypes";
import {HttpClient} from "../../helpers";

const API_BASE_URL = '/api/Settings';

export const settingService = {
    async updateSettingValue(request: UpdateSettingValueRequest): Promise<BaseResponseType<SettingResult>> {
        const response = await HttpClient.put<BaseResponseType<SettingResult>>(`${API_BASE_URL}/UpdateSettingValue`, request);
        return response;
    },

    async getSettingValue(key: string): Promise<BaseResponseType<SettingResult>> {
       return await HttpClient.get<BaseResponseType<SettingResult>>(`${API_BASE_URL}/GetSettingValue`, {
            params: { key }
        });
    }
};

